export default "__VITE_ASSET__BQSq0s7e__"